const router = [
    {
        path: '/person/list',
        component: () => import('../views/Person/List.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/person/detail',
        component: () => import('../views/Person/Detail.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/person/remark',
        component: () => import('../views/Person/Remark.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/person/good',
        component: () => import('../views/Person/Good.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        },
    },
    {
        path: '/person/bad',
        component: () => import('../views/Person/Bad.vue'),
        beforeEnter(to, from, next) {
            document.title = '聊城房屋交易租赁平台';
            next()
        }
    },
]
export default router
